
    var riot = require('riot')
    riot.tag2('kf-raw', '<span></span>', '', '', function(opts) {
    this.on('mount', insert);
    this.on('update', insert);
    function insert() {
      this.root.innerHTML = this.opts.html;
    }
});
    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('kf-raw')
    }
  }
  